/// <amd-module name="Search/Shared/Components/LoadMore" />
export * from "./LoadMore/index";
